// Request helpers for the dashboard widget data provider.

/**
 * Create dashboard editor request params.
 *
 * @param {*} provider
 */
export function createDashboardEditorRequestParams(provider) {
    return {
        ownerType: provider.getOwnerType(),
        ownerId: provider.getOwnerId(),
    };
}

/**
 * Get dashboard editor request params.
 *
 * @param {*} provider
 */
export function getDashboardEditorRequestParams(provider) {
    const params = createDashboardEditorRequestParams(provider);
    const dashboardId = provider.getDashboardId();

    if (dashboardId) {
        params.dashboardId = dashboardId;
    }

    return params;
}

export async function fetchDashboardEditorInterface(provider) {
    return provider.vue.$get(
        provider.getDashboardLayoutEditorUrl('/interface'),
        provider.getEditorRequestParams()
    );
}

export async function fetchDashboardEditorData(provider) {
    return provider.vue.$get(
        provider.getDashboardLayoutEditorUrl(),
        provider.getEditorRequestParams()
    );
}

export async function saveDashboardEditorData(provider, breakpoints, widgets) {
    return provider.vue.$post(
        provider.getDashboardLayoutEditorUrl('/save'),
        provider.buildDashboardPayload(breakpoints, widgets),
        provider.getEditorRequestParams()
    );
}
